<template>
  <section>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      src="@/assets/img/bgDrawer.jpg"
    >
      <v-list>
        <v-list-item>
          <!-- <v-list-item-avatar> Putra </v-list-item-avatar> -->
          <v-list-item-content>
            <v-list-item-title style="font-family: Yeseva One; font-size: 1.2rem"
              >Putra Hidayat Arifin</v-list-item-title
            >
            <v-list-item-subtitle>Web Developer</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          @click="$vuetify.goTo(link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title style="font-family: Roboto; font-size: 1rem">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      :class="{ expand: flat }"
      title="Menu Button"
    >
      <v-toolbar-title
        class="myname"
        style="
          position: absolute;
          left: 25px;

          font-family: 'Yeseva One';
          font-style: normal;
          font-weight: 400;
          font-size: 24px;
          line-height: 28px;
        "
        data-text="Putra Hidayat Arifin"
      >
        Putra Hidayat Arifin
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
        title="Button Menu"
      />
      <div
        style="
          font-family: 'Tiro Kannada';
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 36px;
        "
        v-else
      >
        <v-hover v-slot="{ hover }">
          <a href="#home" v-smooth-scroll>
            <v-btn
              :style="{ 'background-color': hover ? '#FF8E3C' : 'transparent' }"
              height="50"
              text
            >
              <span class="mr-2">Home</span>
            </v-btn>
          </a>
        </v-hover>
        <v-hover v-slot="{ hover }">
          <a href="#about" v-smooth-scroll>
            <v-btn
              :style="{ 'background-color': hover ? '#FF8E3C' : 'transparent' }"
              height="50"
              text
            >
              <span class="mr-2">About</span>
            </v-btn>
          </a>
        </v-hover>
        <v-hover v-slot="{ hover }">
          <a href="#skill" v-smooth-scroll>
            <v-btn
              :style="{ 'background-color': hover ? '#FF8E3C' : 'transparent' }"
              height="50"
              text
            >
              <span class="mr-2">Skill</span>
            </v-btn>
          </a>
        </v-hover>
        <v-hover v-slot="{ hover }">
          <a href="#project" v-smooth-scroll>
            <v-btn
              :style="{ 'background-color': hover ? '#FF8E3C' : 'transparent' }"
              height="50"
              text
            >
              <span class="mr-2">Project</span>
            </v-btn>
          </a>
        </v-hover>
        <v-hover v-slot="{ hover }">
          <a href="#contact" v-smooth-scroll>
            <v-btn
              :style="{ 'background-color': hover ? '#FF8E3C' : 'transparent' }"
              style="margin-right: 25px"
              rounded
              outlined
              text
            >
              <span class="mr-2">Contact Me</span>
            </v-btn>
          </a>
        </v-hover>
      </div>
    </v-app-bar>
  </section>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
.myname::before {
  height: 100%;
  color: var(--var1);
  overflow: hidden;
  position: absolute;
  content: attr(data-text);
  border-right: 2px solid var(--var1);
  -webkit-text-stroke: 0vw var(--var6);
  animation: animate 7s linear infinite;
}
@keyframes animate {
  0%,
  10%,
  100% {
    width: 0;
  }

  70%,
  90% {
    width: 100%;
  }
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-home-outline", "Home", "#home"],
      ["mdi-information-outline", "About", "#about"],
      ["mdi-brain", "Skill", "#skill"],
      ["mdi-walk", "Project", "#project"],
      ["mdi-phone-outline", "Contact Me", "#contact"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
